// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + {"472":"settings","542":"game-tout","964":"billing"}[chunkId] + ".js?id=" + {"472":"8ea204bf97d3c08b","542":"7f544d4e0b708838","964":"c56804ae358f4ede"}[chunkId] + "";
};